// Make this page defaul to download assets of webservice


import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,Events,AlertController } from 'ionic-angular';

import {Webservice} from '../../providers/webservice'
import { Dashboard } from '../dashboard/dashboard'
import { MenuController } from 'ionic-angular';
import { Storagehelper } from '../../providers/storagehelper'
import { Filetransfer } from '../../providers/filetransfer'

/**
 * Generated class for the Updatepage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-updatepage',
  templateUrl: 'updatepage.html',
})
export class Updatepage {

	public progress;
	public downloadComplete;
	private filesToDownload;
	private totalDownloadedByte;
	public currentlyDownloading;
	public downloadedFile;
	public totalFiles;

	private delayprogressUpdate;

	private fakeProgress;
	constructor(public navCtrl: NavController, public navParams: NavParams,public webservice:Webservice,public event:Events,public menuctrl:MenuController,public storage:Storagehelper,public filetransfer:Filetransfer,public alertctrl:AlertController) {
		
		this.progress=0; 
		this.downloadComplete=false;
		this.currentlyDownloading="";
		this.downloadedFile=0;
		this.totalFiles=0;
		this.fileDownloadIndex=0;
		this.filesToDownload=[];
		
		this.fakeProgress=0;
		this.delayprogressUpdate=0;

		this.totalDownloadedByte=0;
		this.event.subscribe('app:updateProgress',(progressEvent)=>{
			this.updateProgress();
	    })
		this.event.subscribe('app:downloadProgress',(data)=>{
			var progressEvent=data.progressEvent;
			// console.log("update progress now");
			this.delayprogressUpdate++;
			if(progressEvent.lengthComputable){

				// console.log("Fakeprogress "+this.fakeProgress + "KB");
				// this.clearFakeProgress();
				this.totalDownloadedByte=(this.totalDownloadedByte) + (progressEvent.loaded-this.fakeProgress);
				//this.updateProgress();
				this.fakeProgress=(progressEvent.loaded);
				if(this.delayprogressUpdate>200){
					this.delayprogressUpdate=0;
					console.log("Progress loaded : "+progressEvent.loaded+", Total data : " + progressEvent.total  )
					this.event.publish("app:updateProgress");
				}
				
			}

	    })

		this.loadAppData();
	}

	ionViewDidLoad() {
	console.log('ionViewDidLoad Updatepage');
	}


	// loadAppData(){
	// 	this.progress=50;
	// 	return this.webservice.getAllData();

	// }

	loadAppData(){
		this.webservice.getAllData().then(()=>{
			console.log("Publishing event")
			var $self=this;
			//setTimeout(()=>{

				$self.downloadAppData().then(()=>{
					$self.event.publish('app:loadedDataFromServer');
					// this.navCtrl.push(Dashboard);
					$self.event.publish("app:goBack");
				})
			//},1000)
			
		},(err)=>{
			let alert=this.alertctrl.create({
			  			title:"Snorkel",
			  			message:'Det gick inte att ansluta till servern',
			  			buttons:[{
			  				text:'OK',
			  				role:'cancel'
			  			}]
			  		})
			  		alert.present();
			this.storage.getStorageItem("pagelist").then((data)=>{
				if(data!=undefined){
					this.event.publish('app:loadedDataFromServer');
					// this.navCtrl.push(Dashboard);
					this.event.publish("app:goBack");
				}
			});
		})
	}


	private fileDownloadIndex;

	downloadAppData(){

		return new Promise<String>((resolve,reject)=>{
			// this.downloadComplete=true;
			// resolve();

			this.storage.getStorageItem("pagelist").then((data)=>{

				// if(data.bgImageUrl!=""){
				// 	this.filetransfer.downloadImage(data.bgImageUrl);
				// }


				// if(data.bgImageUrl!=""){
				// 	this.filetransfer.downloadImage(data.bgImageUrl);
				// }

				this.filesToDownload=this.computeFilesToDownload(data);

				this.currentlyDownloading="Bild";
				console.log(this.filesToDownload);
				this.downloadedFile=0;
				this.totalFiles=this.filesToDownload.images.length;
				this.fileDownloadIndex=0;
				this.downloadFile(this.fileDownloadIndex,"images").then(()=>{
					this.downloadComplete=true;
					resolve();
				})

    		})
 
		})

	}
	
	downloadFile(fileIndex,filetype){

		console.log("Total file size : "+this.filesToDownload[filetype][fileIndex]['size']  )
		console.log("downloaded files "+this.downloadedFile);
		return new Promise<String>((resolve,reject)=>{
			if(filetype=="images"){
				console.log(fileIndex);
				var $self=this;
				this.filetransfer.saveFileLocallyForUpdate(this.filesToDownload[filetype][fileIndex]['url'],"images").then((localurl)=>{
	     			console.log("File download completed")
	     			console.log("fake progress : "+ this.fakeProgress)
	     			this.totalDownloadedByte-=this.fakeProgress;
	     			this.totalDownloadedByte+=this.filesToDownload[filetype][fileIndex]['size'];
	     			// console.log("size downloaded " + this.totalDownloadedByte);
	     			// console.log("Percentage complete " + this.progress);
	     			this.fakeProgress=0;
	     			this.updateProgress();
					// this.progress-=this.fakeProgress;
					
					
					if(this.filesToDownload[filetype].length<=(fileIndex+1)){
						
						setTimeout(()=>{
								resolve();
						},500)
					}else{
						this.downloadedFile+=1;
						setTimeout(()=>{
							$self.downloadFile(fileIndex+1,"images").then(()=>{
								resolve();
							})
						},500)
					}
				
	     			
	     		},(err)=>{
	     			this.totalDownloadedByte-=this.fakeProgress;
	     			this.totalDownloadedByte+=this.filesToDownload[filetype][fileIndex]['size'];
	     			this.fakeProgress=0;
					if(this.filesToDownload[filetype].length<=(fileIndex+1)){

						this.currentlyDownloading="Audio";
						this.downloadedFile=0;
						this.totalFiles=this.filesToDownload["audio"].length;
						// this.downloadFile(0,"audio").then(()=>{
						resolve();
						// })
						
					}else{
						this.downloadedFile+=1;
						
						setTimeout(()=>{
							$self.downloadFile(fileIndex+1,"images").then(()=>{
								resolve();
							})
						},500)
					}
	     		});
				
			}

			
		})

	}

	clearFakeProgress(){
		// var fakedPercent=Math.floor((this.fakeProgress/this.filesToDownload.totalfilesize)*100);
		// this.progress-=fakedPercent;
		// console.log("Cleared % : "+fakedPercent+", faked data =  "+this.fakeProgress);
		this.totalDownloadedByte-=this.fakeProgress;
	}

	updateProgress(){
		console.log("updating progress");
		var completedpercentage=(this.totalDownloadedByte/this.filesToDownload.totalfilesize)*100;
		this.progress=Math.floor(completedpercentage);

		console.log("Total size : "+this.filesToDownload.totalfilesize  )
		console.log("Current progress : "+this.progress+'%, downloaded byte + ' + this.totalDownloadedByte+', total file size to download: '+this.filesToDownload.totalfilesize);
	}

	computeFilesToDownload(data){

		var result={images:[],videos:[],audio:[],totalfilesize:0};
		data.forEach((e,i)=>{


			if(e.bgImageUrl!=""){
				
				result.images.push({url:e.bgImageUrl,pageID:e.Id,size:e.bgImageFileSize});	
				result.totalfilesize+=e.bgImageFileSize;

			}

		})
		return result;

	}

	goToDashboard(){
	 	this.navCtrl.popToRoot();
     	this.menuctrl.close();
      	this.navCtrl.setRoot(Dashboard);

	}

}



// WEBPACK FOOTER //
// ./src/pages/updatepage/updatepage.ts